import React from "react";

const Chapter6 = () => {
  return (
    <>
      <h2>What are the water quality standards for nutrients</h2>
      <p>
        Phosphorus contamination is measured in milligrams per liter (mg/L) or
        micrograms per liter (μg/L) There is not a national drinking water
        standard for phosphorus.
      </p>
      <ul>
        <li>
          The State of Colorado began implementing a new phosphorous standard in
          2015 to protect aquatic life. The standard, which is 0.17 mg/L, is
          being implemented on small streams first and will be fully implemented
          in 2022.
        </li>
      </ul>
      <p>Nitrate contamination is measured in milligrams per liter (mg/L).</p>
      <ul>
        <li>The national drinking water standard for nitrate is 10 mg/L.</li>
        <li>
          The State of Colorado began implementing a new total nitrogen standard
          in 2015 to protect aquatic life. The standard, which is 2.01 mg/L,
          will be fully implemented in 2022.
        </li>
      </ul>
    </>
  );
};

export default Chapter6;
